import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const store = new Vuex.Store({
  //   plugins: [createPersistedState()],
  state: {
    navList: [],
    nursery_school: "",
    school_type: "",
  },
  mutations: {
    setUserInfo(state, userInfo) {
      // console.log(state)
      // console.log(userInfo)
      state.navList = userInfo
    },
    setSchool(state, school) {
      state.nursery_school = school.nursery_school;
      state.school_type = school.school_type;
      localStorage.removeItem("school");
      localStorage.setItem('school', JSON.stringify(school));

    },
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js